import { Injectable } from '@angular/core';

export enum Role {
  Officer = 501, // مأمور ضبط
  Study = 502, // دارس
  Supervisor = 503, // مشرف
  Manager = 504, // مدير
  Quality = 505  // جودة
}

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor() { }
  getRoleName(roleId: number): string {
    switch (roleId) {
      case Role.Officer:
        return 'مأمور ضبط';
      case Role.Study:
        return 'دارس';
      case Role.Supervisor:
        return 'مشرف';
      case Role.Manager:
        return 'مدير';
      case Role.Quality:
        return 'جودة';
      default:
        return 'غير معروف';
    }
  }
}
